import React from 'react'
import {
  InteractiveDialog,
  InstructionsPure,
  GridSelectionHLPure,
  CheckBoxHLPure,
  LabelHLPure,
  ButtonHLPure
} from '../../pures'
import { useTranslation } from 'react-i18next'
import styles from './dialogExtractEntities.module.css'

const HeaderColumns = ({ t, title }) => {
  return <span className={(title === t('documentPanelBarEntities.grid.title.1')) ? 'grid-header-one' : 'grid-headers'}>{title}</span>
}

const CellColumnNameDoc = ({ t, dataItem }) => {
  return (
    <td>
      <div className='grid-cell-double-container-margin-left'>
        <p className='grid-cell-titles'>{dataItem.name}</p>
        <p className='grid-cell-subtitles'>{`${dataItem.pages} ${t('digitalVaultUploadView.pages')}`}</p>
      </div>
    </td>
  )
}

const CellColumnsText = ({ t, dataItem, column }) => {
  let content = ''
  if (column === 2) content = dataItem.process
  if (column === 3) content = dataItem.unitary
  if (column === 6) content = dataItem.credits

  return (
    <td>
      <div>
        <p className='grid-cell-subtitles'>{content}</p>
      </div>
    </td>
  )
}

const CellColumnCheckBoxDocs = ({ dataItem, onClickCheckBox }) => {
  return (
    <td>
      <div className={styles['dialogExtractEntities-checkbox']}>
        <CheckBoxHLPure
          valueCheckBox={dataItem.value}
          checkedState={dataItem.value}
          onChangeHandler={(e) => onClickCheckBox(e, dataItem)}
        />
      </div>
    </td>
  )
}

const DialogExtractEntities = ({ documentsToOCR, totalCredits, onClickCheckBox, closeModalEntities, saveEntities, onClickSkipBtn }) => {
  const { t } = useTranslation()

  const headersColumns = (props) => <HeaderColumns {...props} t={t} />

  const cellColumnNameDoc = (props) => <CellColumnNameDoc {...props} t={t} />
  const cellColumnTwoDocs = (props) => <CellColumnsText {...props} t={t} column={2} />
  const cellColumnThreeDocs = (props) => <CellColumnsText {...props} t={t} column={3} />
  const cellColumnFourDocs = (props) => <CellColumnCheckBoxDocs {...props} t={t} onClickCheckBox={onClickCheckBox} />
  const cellColumnSixDocs = (props) => <CellColumnsText {...props} t={t} column={6} />

  return (
    <InteractiveDialog
      title={t('digitalVaultUploadView.modal.entities.title')}
      saveBtnTitle={t('digitalVaultUploadView.modal.entities.btn.save')}
      cancelBtnTitle={t('dialogExtractEntities.cancelled')}
      onClose={() => closeModalEntities()}
      onSave={() => saveEntities()}
    >
      <div className={styles['dialogExtractEntities-container']}>
        <InstructionsPure instructions={[t('digitalVaultUploadView.modal.entities.description')]} />
        <div className={(documentsToOCR.length >= 3) ? styles['dialogExtractEntities-grid.scroll'] : styles['dialogExtractEntities-grid']}>
          <GridSelectionHLPure
            pageable={false}
            skip={0}
            take={documentsToOCR.length}
            dataGrid={documentsToOCR}
            filter={true}

            columnTwo={true}
            columnThree={true}
            columnFour={true}
            columnSix={true}

            titleRow1={t('digitalVaultUploadView.modal.entities.grid.title.1')}
            titleRow2={t('digitalVaultUploadView.modal.entities.grid.title.2')}
            titleRow3={t('digitalVaultUploadView.modal.entities.grid.title.3')}
            titleRow4={t('digitalVaultUploadView.modal.entities.grid.title.3')}
            titleRow6={t('digitalVaultUploadView.modal.entities.grid.title.6')}

            headerColumnOne={headersColumns}
            headerColumnTwo={headersColumns}
            headerColumnThree={headersColumns}
            headerColumnFour={headersColumns}
            headerColumnSix={headersColumns}

            cellColumnOne={cellColumnNameDoc}
            cellColumnTwo={cellColumnTwoDocs}
            cellColumnThree={cellColumnThreeDocs}
            cellColumnFour={cellColumnFourDocs}
            cellColumnSix={cellColumnSixDocs}

            widthColumnOne={'100px'}
            widthColumnTwo={'50px'}
            widthColumnThree={'70px'}
            widthColumnFour={'30px'}
            widthColumnSix={'30px'}

            minResizableWidth1={'auto'}
            minResizableWidth2={'50px'}
            minResizableWidth3={'70px'}
            minResizableWidth4={'30px'}
            minResizableWidth5={'30px'}
          />
        </div>
        <div className={styles['dialogExtractEntities-credits']}>
          <LabelHLPure text={`${t('digitalVaultUploadView.modal.entities.total.credits')}: ${totalCredits}`} fontSize='18px' />
        </div>
      </div>
    </InteractiveDialog>
  )

}

export { DialogExtractEntities as default }